import React from "react";
import { FormLayout, Modal, Text, TextField } from "@shopify/polaris";

export default function FillQuantitiesModal({
  closeFillQuantitiesModal,
  fillQuantitiesModalOpen,
  setFillQuantities,
  fillQuantity,
  handleFillQuantityChange,
}: {
  readonly closeFillQuantitiesModal: () => void;
  readonly fillQuantitiesModalOpen: boolean;
  readonly setFillQuantities: (quantity: number) => void;
  readonly fillQuantity: number;
  readonly handleFillQuantityChange: (value: string) => void;
}): React.ReactElement {
  return (<Modal
    onClose={closeFillQuantitiesModal}
    open={fillQuantitiesModalOpen}
    primaryAction={{
      content: "Fill all",
      onAction: () => {
        setFillQuantities(fillQuantity);
        closeFillQuantitiesModal();
      },
    }}
    secondaryActions={[{ content: "Cancel", onAction: closeFillQuantitiesModal }]}
    title="Fill all variant quantities"
  >
    <Modal.Section>
      <FormLayout>
        <Text as="p">Order enough to bring all available quantities up to a fixed value.</Text>
        <FormLayout.Group>
          <TextField
            autoComplete="off"
            label="Fill quantity"
            onChange={handleFillQuantityChange}
            suffix="pieces"
            value={fillQuantity?.toString() || ""}
          />
        </FormLayout.Group>
      </FormLayout>
    </Modal.Section>
  </Modal>);
};
